module.exports = __webpack_public_path__ + "img/xiaochengxu.a6cc708a.png";